import React, {Fragment} from "react";

import './ConnectionPair.scss' ;
import {TableActionIconAlert, TableActionIconDelete, TableActionIconEdit} from "root/Tables/BaseTableComponents";
import IconTooltip from "root/UI/Tooltip/IconTooltip";
import {UserGroupTypes, UserTypes} from "root/DataFunctions/Constants";
import {useGlobalContext} from "root/contexts/GlobalContext";
import {Link} from "react-router-dom";

const ConnectionPair = ({clickHandler, data}) =>
{
    const { userType } = useGlobalContext() ;

    const rightsRenderer = (row) => {
        const isManager = !!row.manager;
        const isEditor = !!row.editor;
        const isContributor = !!row.contributor;
        const isMessager = !!row.messager;
        const isMailer = !!row.mailer;
        const viaLetterbox = +(row.is_letterbox_required) === 1 ;
        const hasContactPlan = +(row.has_contact_plan) === 1 ;
        const messagerButtonClass = (isMessager && viaLetterbox ) ? 'letterbox' : '' ;
        const mailerButtonClass = (isMailer && viaLetterbox) ? 'letterbox' : '' ;
        const hasContactPlanClass = (hasContactPlan) ? 'hasContactPlan' : '' ;
        const messagerToolText = (isMessager && viaLetterbox ) ? 'Can send messages via letterbox' : 'Can send messages' ;
        const lettersToolText = (isMailer && viaLetterbox ) ? 'Can send letters/cards via letterbox' : 'Can send letters/cards' ;

        return (
            <div>
                <span>
                    {hasContactPlan && <IconTooltip text='Has Communications Plan'><div className={"connection-button " + hasContactPlanClass}>CP</div></IconTooltip>}
                    {isMailer && <IconTooltip text={lettersToolText}><div className={"connection-button " + mailerButtonClass}>L</div></IconTooltip>}
                    {isManager && <IconTooltip text='Can Manage Child'><div className="connection-button">M</div></IconTooltip>}
                    {isEditor && <IconTooltip text='Is Editor For Child'><div className="connection-button">E</div></IconTooltip>}
                    {isContributor && <IconTooltip text='Is Life Story Contributor'><div className="connection-button">C</div></IconTooltip>}
                    {isMessager && <IconTooltip text={messagerToolText}><div className={"connection-button " + messagerButtonClass} ><i className="icon icon-email" style={{ marginBottom: '3px'}}/></div></IconTooltip>}
                </span>
            </div>
        );
    };

    const linkFormatter = (row) =>
    {
        // const current_child = useRecoilValue(currentChildAtom);
        const loggedOnUserIsStaff = phpVars.user_type_group === UserGroupTypes.USER_GROUP_STAFF ? true : false;
        const hasContactPlan = +(row.has_contact_plan) === 1 ;
        const canManageRights = loggedOnUserIsStaff || !hasContactPlan
        const connectionIsBlocked = +row.blocked === 1;
        // const isManager = current_child.is_manager;
        // const isEditor = current_child.is_editor;
        // const canUnblock = isManager || isEditor || loggedOnUserIsStaff;

        return (
            <Fragment>
                {canManageRights && !connectionIsBlocked && <TableActionIconEdit text="Edit Permissions" onClick={() => onClickItem('edit', row, null)} />}
                {connectionIsBlocked && loggedOnUserIsStaff && <TableActionIconAlert text="Unblock User" onClick={() => onClickItem('unblock', row, null)} />}
            </Fragment>
        );
    }

    const connectionFormatter = (row0, row1) =>
    {
        const loggedOnUserIsStaff = phpVars.user_type_group === UserGroupTypes.USER_GROUP_STAFF ? true : false;
        const hasContactPlan = +(row0.has_contact_plan) === 1 ;
        const canManagerights = loggedOnUserIsStaff || !hasContactPlan;

        return (
            <Fragment>
                {canManagerights && <TableActionIconDelete text="Remove connection" onClick={() => onClickItem('delete', row0, row1)} />}
            </Fragment>
        );
    }

    const onClickItem = (mode, row0, row1) =>
    {
        clickHandler(mode, row0, row1 );
    }

    const pairTitle  = (data) =>{
        const relation_name = userType === UserTypes.FOREVER_PARENT && data['adopted_name'] !== null  && data['adopted_name'] !== '' ? data['adopted_name'] : data['user_name'];
        const title = relation_name + ' - ' + data['user_typeName']
        return title;
    }

    const checkBlocked  = (data) =>{
        const blockedText = +(data.blocked) === 1 ? 'BLOCKED' : '';
        return blockedText;
    }

    const connectionTitle1  = (data) =>{
        const relation_name = userType === UserTypes.FOREVER_PARENT && data['relation_adopted_name'] !== null && data['relation_adopted_name'] !== '' ? data['relation_adopted_name'] : data['relation_name'];
        const user_name = userType === UserTypes.FOREVER_PARENT && data['adopted_name'] !== null && data['adopted_name'] !== '' ? data['adopted_name'] : data['user_name'];
        const title = user_name + ' - known to ' + relation_name + ' as ' + data['user_known_as'];
        return title;
    }

    const connectionTitle2  = (data) =>{
        const relation_name = userType === UserTypes.FOREVER_PARENT && data['adopted_name'] !== null && data['adopted_name'] !== '' ? data['adopted_name'] : data['user_name'];
        const user_name = userType === UserTypes.FOREVER_PARENT && data['relation_adopted_name'] !== null && data['relation_adopted_name'] !== '' ? data['relation_adopted_name'] : data['relation_name'];
        const title = relation_name + ' - known to ' + user_name + ' as ' + data['user_known_as'];
        return title;
    }

    const displayNotes  = (data) =>{
        const notes = data['relation_notes'];
        const shortNotes = notes != null && notes.length > 70 ? notes.slice(0, 70) + '...' : notes;
        return shortNotes;
    }

    const loggedOnUserIsStaff = phpVars.user_type_group === UserGroupTypes.USER_GROUP_STAFF ? true : false;

    const u1URL = '/home/users/' + data[0].ur_idusers + '/connections?name=' + data[0].user_name ;

    return (
        <Fragment>
            <div className='connection-pair'>
                <div className='connection-row'>
                    <div className='conn-header'><Link to={u1URL}>{pairTitle(data[0])}</Link></div>

                    {loggedOnUserIsStaff && <div className='cr-notes-header'>Notes</div>}
                    {!loggedOnUserIsStaff && <div className='cr-notes-header'></div>}

                    <div className='cr-edit-icons-header'>Permissions</div>

                    <div className='cr-image-icons'>
                        <div>{connectionFormatter(data[0], data[1])}</div>
                    </div>
                </div>


                <div className='connection-row'>
                    <div className='cr-name'><p>{connectionTitle1(data[0])}</p><span style={{color:"red"}}>{checkBlocked(data[0])}</span></div>

                    {loggedOnUserIsStaff && <div className='cr-notes'><p>{displayNotes(data[0])}</p></div>}
                    {!loggedOnUserIsStaff && <div className='cr-notes'><p></p></div>}

                    <div className='cr-edit-icons'>
                        <div>{rightsRenderer(data[0])}</div>
                    </div>

                    <div className='cr-image-icons'>
                        <div>{linkFormatter(data[0])}</div>
                    </div>
                </div>

                <hr></hr>

                <div className='connection-row'>
                    <div className='cr-name'><p>{connectionTitle2(data[1])}</p><span style={{color:"red"}}>{checkBlocked(data[1])}</span></div>

                    {loggedOnUserIsStaff && <div className='cr-notes'><p>{displayNotes(data[1])}</p></div>}
                    {!loggedOnUserIsStaff && <div className='cr-notes'><p></p></div>}

                    <div className='cr-edit-icons'>
                        <div>{rightsRenderer(data[1])}</div>
                    </div>

                    <div className='cr-image-icons'>
                        <div>{linkFormatter(data[1])}</div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default ConnectionPair ;
